"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["type", "variant", "children"];
/*
* SVB Typography
* <SVBTypography type="heading-medium" variant="bold underline">Heading Large</SVBTypography>
* props
* type: define the font-type (applies size, weight, spacing and line-height)
* variant: to define the font-style (adds variant as a html class. for e.g. bold, underline or any other custom-classes that need to be added)
*/
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// Defining the HTML tag that the component will translate to
const variantsMapping = {
  "heading-xlarge": "h1",
  "heading-large": "h2",
  "heading-medium": "h3",
  "heading-small": "h4",
  "sub-heading-large": "h5",
  "sub-heading": "h6",
  "paragraph": "p"
};

/**
 * SVBTypography
 * @param type: the selected html tag
 * @param variant: additional styling classes
 * @param children: the node passed inside the Component
 * @returns HTML tag with content
 */

const SVBTypography = _ref => {
  let {
      type,
      variant,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  // If the variant exists in variantsMapping, we use it. 
  // Otherwise, use p tag instead.
  const Component = type ? variantsMapping[type] : "p";
  const typeClass = type ? type : '';
  const variantClass = variant ? variant : '';
  const Classes = typeClass + ' ' + variantClass;
  return /*#__PURE__*/_react.default.createElement(Component, {
    className: Classes
  }, children);
};
var _default = SVBTypography;
exports.default = _default;